"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFileMetadata = void 0;
var metadata_1 = require("../metadata");
var file_descriptor_parser_1 = require("./file-descriptor-parser");
/**
 * @param {Image} image
 * @param {FileMetadata} fileMetadata
 * @returns Image
 */
function parseFileMetadata(image, fileMetadata) {
    file_descriptor_parser_1.parseFileDescriptor(image, fileMetadata.fileDescriptor);
    if (fileMetadata.basic) {
        image.metadata = new metadata_1.Metadata(fileMetadata.basic.width, fileMetadata.basic.height, fileMetadata.fileDescriptor.mimeType);
    }
}
exports.parseFileMetadata = parseFileMetadata;
//# sourceMappingURL=file-metadata-parser.js.map